/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ service: NonNullable<unknown> }} Directory_Meta_Description_ServiceInputs */

const en_directory_meta_description_service = /** @type {(inputs: Directory_Meta_Description_ServiceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.service}: specialists with prices and open times. Book online, no account needed to browse.`)
};

const pl_directory_meta_description_service = /** @type {(inputs: Directory_Meta_Description_ServiceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.service}: specjaliści z cenami i wolnymi terminami. Umów się online, przeglądasz bez konta.`)
};

/**
* | output |
* | --- |
* | "{service}: specialists with prices and open times. Book online, no account needed to browse." |
*
* @param {Directory_Meta_Description_ServiceInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const directory_meta_description_service = /** @type {((inputs: Directory_Meta_Description_ServiceInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Meta_Description_ServiceInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_directory_meta_description_service(inputs)
	return en_directory_meta_description_service(inputs)
});